import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCanvaComponent } from './simple-icons-canva.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCanvaComponent ],
    exports:      [ SimpleIconsCanvaComponent ],
    bootstrap:    []
})
export class SimpleIconsCanvaModule {}
